export default "__VITE_ASSET__BJ5hbE2w__"